import React from 'react'
import { useTranslation } from 'react-i18next'
import { Highlight, Icon } from '@node-space/ui-components'
import { ConditionalTooltip } from 'components/Conditional/ConditionalTooltip'
import { CardStatus } from 'services/CardService'
import { getStatusHighlightProps } from './utils/cardUtils'

interface CardStatusHighlightProps {
  status: CardStatus
}

export const CardStatusHighlight = ({ status }: CardStatusHighlightProps) => {
  const { t } = useTranslation()
  const statusProps = getStatusHighlightProps(status)

  return (
    <ConditionalTooltip
      isEnabled={status === 'BLOCKED'}
      bodyContent={t('customers.cardDetails.statusBlockedTooltip')}
      type="simple"
      position="bottom"
      triggerAsChild={false}
    >
      <Highlight
        iconElement={<Icon name="CheckCircle" size="small" />}
        variant="status"
        type={statusProps.type}
      >
        {t(statusProps.labelKey)}
      </Highlight>
    </ConditionalTooltip>
  )
}
